(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('securityEventsPieCharts', ["path", "$q", "modulesDao", "securityEventsDao", "severityTypes", "timeResolutions", "securityEventStates", "modulesManager", "defaultChartColorList", function (path, $q, modulesDao, securityEventsDao, severityTypes, timeResolutions, securityEventStates, modulesManager, defaultChartColorList) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('security-events/pie-charts').template('pie-charts'),
            scope: {
                resolution: '=',
                filters: '=',
                filterBy: '=',
                widgetApi: '=?api',
                secEventsApi: '='
            },
            link: function ($scope, element, attrs) {
                $scope.widgetApi = $scope.widgetApi || {};
                $scope.severityTypes = severityTypes.data;
                $scope.securityEventsTypes = securityEventStates.data;
                $scope.saasTypes = [];
                $scope.chartVisible = true;
                $scope.loadingFirstTime = true;
                function getData(type) {
                    var params = { filterBy: $scope.filterBy };
                    params = _.extend(params, _($scope.filters).chain().reduce(function (memo, filter) {
                        var t = 'filterEnum_' + filter.type;
                        memo[t] = memo[t] || [];
                        memo[t].push(filter.id);
                        return memo;
                    }, {}).mapObject(function (val) {
                        return val.join(',');
                    }).value());
                    if (timeResolutions.get($scope.resolution)) {
                        params = _.extend(params, {
                            resolutionColumn: 'create_time',
                            resolutionStep: $scope.resolution,
                            resolutionFromNow: true,
                            resolutionMax: 1,
                            resolutionFields: type
                        });
                    } else {
                        params = _.extend(params, { groupBy: type });
                    }
                    var result = securityEventsDao.list();
                    result.params(params);
                    return result;
                }
                $scope.loadData = function () {
                    return $q.all([
                        getData('severity'),
                        getData('current_state'),
                        getData('saas')
                    ]).then(function (responses) {
                        $scope.saasTypes = composeLabelsMap();
                        var charts = [
                            {
                                label: 'Events by Severity',
                                field: 'severity',
                                raw: responses[0].data.rows,
                                variants: $scope.severityTypes,
                                colors: defaultChartColorList
                            },
                            {
                                label: 'Events by State',
                                field: 'current_state',
                                raw: responses[1].data.rows,
                                variants: $scope.securityEventsTypes,
                                colors: [
                                    '#e63c53',
                                    '#91ce55',
                                    '#fec543'
                                ]
                            },
                            {
                                label: 'Events by SaaS',
                                field: 'saas',
                                raw: responses[2].data.rows,
                                variants: $scope.saasTypes,
                                colors: defaultChartColorList
                            }
                        ];
                        _(charts).each(function (chart) {
                            chart.show = chart.raw && chart.raw.length > 0;
                            chart.model = {
                                watchFlotOptions: false,
                                flotOptions: {
                                    series: {
                                        pie: {
                                            show: true,
                                            highlight: { opacity: 0.2 },
                                            innerRadius: 0.67,
                                            stroke: { width: 0 }
                                        }
                                    },
                                    colors: chart.colors,
                                    grid: {
                                        hoverable: true,
                                        clickable: true
                                    },
                                    legend: {
                                        labelFormatter: function (label, series) {
                                            return label;
                                        }
                                    },
                                    tooltip: true,
                                    tooltipOpts: {
                                        defaultTheme: false,
                                        content: '%s',
                                        shifts: {
                                            x: 0,
                                            y: 20
                                        },
                                        cssClass: 'pieChartTip',
                                        disableCentering: true
                                    }
                                },
                                flotOnClick: function (event, pos, obj) {
                                    $scope.secEventsApi.updateFilter(chart.field, { removeAll: true }, true);
                                    $scope.secEventsApi.updateFilter(chart.field, obj.series.variant, false);
                                },
                                legendOnClick: function (event) {
                                    var variantId = $(event.target).closest('.legend-line').attr('variant-id');
                                    var variant = _(chart.variants).find(function (variant) {
                                        return variant.id == variantId;
                                    });
                                    if (variant) {
                                        $scope.secEventsApi.updateFilter(chart.field, { removeAll: true }, true);
                                        $scope.secEventsApi.updateFilter(chart.field, variant, false);
                                    }
                                }
                            };
                            var chartVariants = chart.variants;
                            if (!chartVariants) {
                                chartVariants = _(chart.raw).map(function (row) {
                                    return {
                                        id: row.label,
                                        label: row.label
                                    };
                                });
                            }
                            chart.model.data = _(chartVariants).chain().map(function (variant) {
                                var found = _(chart.raw).find(function (row) {
                                    return row[chart.field] === variant.id;
                                });
                                var count = found ? found.count : 0;
                                return {
                                    label: '<div class="legend-line" variant-id="' + variant.id + '">' + '<div class="legend-label">' + variant.label.toUpperCase() + '</div>' + '<div class="legend-count">' + count + '</div>' + '</div>',
                                    data: count,
                                    color: variant.color,
                                    variant: variant
                                };
                            }).filter(function (el) {
                                return el.data;
                            }).value();
                        });
                        if (!angular.equals(charts, $scope.charts)) {
                            $scope.charts = charts;
                        }
                        $scope.loadingFirstTime = false;
                    });
                    function composeLabelsMap() {
                        return _(modulesManager.activeSaasApps()).map(function (app) {
                            return {
                                id: app.name,
                                label: app.title
                            };
                        });
                    }
                };
                $scope.toggleVisibility = function () {
                    $scope.chartVisible = !$scope.chartVisible;
                };
            }
        };
    }]);
}());